import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';
import { ITrackingObject, TrackingObjectNamesEnum } from '../../tracking.data';
import { ReportExpandedViewTypesEnum } from '../../../report-data/report-data.data';

export const TRACKING_SCHEMA = Object.freeze({
  REPORT_EXPANDED_IDENTIFIER: ReportExpandedViewTypesEnum,
});
const RECORD = generateSchema(TRACKING_SCHEMA);
const KEYS: any = generateKeys(TRACKING_SCHEMA);

export class ReportExpandedTrackingObject
  extends Record(RECORD)
  implements ITrackingObject {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingObjectNamesEnum.report_expanded;
  }

  get properties() {
    return this.toJS();
  }
}
